import { toExcelDate, toExcelQuantity } from 'components/xlsx/excelCells';
import { ClassifierData } from 'types/classifiers';
import { EffortExportListItemDto } from 'types/efforts';
import { getClassifierText, t } from 'utils/getTranslations';
import { secondsToHours } from 'utils/time';

export const mapEffortsToCSVFormat = (
    efforts: EffortExportListItemDto[],
    classifiers: Record<string, ClassifierData>
) => {
    return efforts?.map((effort) => {
        return {
            [t('efforts.export.date')]: toExcelDate(effort.effortDate),
            [t('efforts.export.used-time-hours')]: toExcelQuantity(secondsToHours(effort.usedTimeInSeconds ?? 0)),
            [t('efforts.export.activity-type')]: getClassifierText(
                classifiers['EFFORT_ACTIVITY_TYPE'],
                effort.effortActivityTypeCode
            ),
            [t('efforts.export.description')]: effort.description ?? '',
            [t('efforts.export.effort-by-colleague')]: (effort.effortsByEmployees || [])
                .flatMap((e) => (e.name ? [e.name] : []))
                .join(', '),
            [t('efforts.export.effort-for-person')]: (effort.effortsForPeople || [])
                .flatMap((p) => (p.name ? [p.name] : []))
                .join(', '),
            [t('efforts.export.effort-for-entity')]: (effort.effortsForCompanies || [])
                .flatMap((p) => (p.name ? [p.name] : []))
                .join(', '),
            [t('efforts.export.resulted-in-cases')]: (effort.effortsResultingInCases || [])
                .flatMap((m) => (m.fullName ? [m.fullName] : []))
                .join(', '),
        };
    });
};
